import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { useAppDispatch, useAuth } from '@/hooks/useAuth';

import { checkAuth } from '@/store/slices/authSlice';

const ProtectedLayout = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isAuthenticated, loading, initialized } = useAuth();

  useEffect(() => {
    if (!initialized && !loading) {
      dispatch(checkAuth());
    }
  }, [initialized, loading, dispatch]);

  useEffect(() => {
    if (initialized && !isAuthenticated) {
      navigate('/');
    }
  }, [initialized, isAuthenticated, navigate]);

  if (!initialized || loading) {
    return (
      <div className='flex min-h-screen items-center justify-center'>
        <div className='text-lg'>Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className='flex min-h-screen w-full flex-col'>
      <main className='flex-1 bg-background'>
        <Outlet />
      </main>
    </div>
  );
};

export default ProtectedLayout;
